import { map } from 'rxjs/operators';
import { Subscription, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';

// @ts-ignore
import { Store } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import { AppState } from '../_reducers/index';
import { UserGroup } from '../_models/userGroup';
import { selectAllUserGroups } from '../_selectors/userGroup.selectors';

@Injectable()
export class UserGroupService {
  private apiBaseUrl = environment.apiBaseUrl;
  private groupList: Observable<UserGroup[]>;
  private subscriptions: Subscription = new Subscription();
  constructor(
    private http: HttpClient,
    private store: Store<AppState>
  ) {
    this.groupList = this.store.select(selectAllUserGroups);
  }

  getFromLocalStore(): Observable<UserGroup[]> {
    return this.groupList;
  }

  getUserGroups(): Observable<UserGroup[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/userGroups')
      .pipe(map((response) => response));
  }

  getUserGroup(id: number): Observable<UserGroup> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/userGroups/' + id)
      .pipe(map((response) => response));
  }

  saveUserGroup(userGroupItem: UserGroup): Observable<UserGroup> {
    const userGroup = { ...userGroupItem };

    delete userGroup.lastUpdated;
    delete userGroup.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    userGroup.companyId = companySelected ? companySelected.id : null;

    if (userGroup.id) {
      return this.http
        .put<UserGroup>(this.apiBaseUrl + 'api/private/v1/userGroups/' + userGroup.id, userGroup)
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<UserGroup>(this.apiBaseUrl + 'api/private/v1/userGroups', userGroup)
        .pipe(map((response) => response));
    }
  }

  deleteUserGroup(id: number): Observable<UserGroup> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/userGroups/' + id).pipe(
      map((response) => {
        return { id } as UserGroup;
      })
    );
  }

  getUserGroupById(id: number) {
    let group: UserGroup;
    this.groupList.subscribe((groups) => {
      group = _.find(groups, function (f) {
        return Number(f.id) === id;
      });
    });
    return group;
  }
}
